<template>
  <div class="layout-console">
    <div class="left"
         :class="$state.layout.collapsed ? 'left-collapsed' : ''">
      <div class="top">
        <component :is="$state.layout.console.left.logo"
                   v-if="$state.layout.console.left.logo" />
      </div>
      <!-- 菜单 -->
      <div class="middle">
        <component :is="item"
                   v-for="(item, i) in $state.layout.console.left.middle"
                   :key="i"> </component>
      </div>
      <div class="bottom"></div>
    </div>
    <div class="main">
      <!-- 头部 -->
      <div class="header">
        <ul class="menu-groups">
          <li v-for="item in menuGroups"
              :key="item.value"
              :class="{ 'menu-group-active': menuType == item.value }"
              @click="changeMenu(item.value)">{{ item.label }}</li>
        </ul>
        <div class="h-left">
          <component :is="item"
                     v-for="(item, i) in $state.layout.console.head.left"
                     :key="i"> </component>
        </div>
        <div class="h-middle"></div>
        <div class="h-right">
          <component :is="item"
                     v-for="(item, i) in $state.layout.console.head.right"
                     :key="i"> </component>
        </div>
      </div>
      <!-- 标签导航 -->
      <div class="navigation">
        <component :is="item"
                   v-for="(item, i) in $state.layout.console.navigation.items"
                   :key="i"> </component>
      </div>
      <div class="content">
        <!-- 路由切换 -->
        <router-view v-slot="{ Component }">
          <transition name="fade-transform">
            <keep-alive :include="$state.layout.cachedViews">
              <component :is="Component" />
            </keep-alive>
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRbacStore } from '@/plugins'
import { useWatermark } from '../../../../../utils/WaterMark'
import { onMounted, computed, ref } from 'vue'
import { CORE_USER, type UserService } from '@/core'
import { container } from 'tsyringe'
import moment from 'moment'
import { useConsolePageLayout } from "../DefaultConsolePagePlugin"
const { $state } = useConsolePageLayout()
const userService = container.resolve<UserService>(CORE_USER)
const user = userService.getUser() as any
const rbacStore = useRbacStore()
const menuType = ref('')
onMounted(() => {
  menuType.value = rbacStore.menus.menuType
  const watermark = useWatermark()
  watermark.setWatermark(user.value.username + moment().format(' YYYY-MM-DD') + ' FLASHBASE', {
    opacity: 0.12,
  })
})
const changeMenu = (val: string) => {
  menuType.value = val
  rbacStore.setMenuType(menuType.value)
}
const menuGroups = computed(() => {
  return rbacStore.menus.tree.map(x => { return { label: x.name, value: x.key } })
})
</script>
<style scoped lang="less">
@import "@/styles/vars.less";

.layout-console {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: hidden;
  font-size: 14px;

  .left {
    display: flex;
    width: 200px;
    flex-direction: column;
    box-shadow: @box-shadow-light;
    z-index: 100;

    &-collapsed {
      width: 80px;
    }

    .top {
      display: flex;
      flex-direction: row;
      height: @head-height;
      justify-content: center;
      align-items: center;
    }

    .middle {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
    }

    .bottom {
      display: flex;
      flex-direction: row;
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    background-color: #f0f2f5;

    .header {
      display: flex;
      flex-direction: row;
      min-height: @head-height;
      justify-content: space-between;
      background-color: #ffffff;
      border-bottom: 2px solid #edeff0;

      .h-left {
        display: flex;
        flex-direction: row;
        align-items: center;

        .system-title {
          margin: 0 10px;
          font-size: 18px;
          color: white;
          line-height: 40px;
        }
      }

      .h-middle {
        display: flex;
        flex-direction: row;
        flex: 1;
      }

      .h-right {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .menu-groups {
        display: flex;
        align-items: center;
        height: 28px;
        margin: 14px 20px;
        margin-right: 0;
        border-radius: 4px;
        background: #E4E7F2;

        >li {
          padding: 3px 10px;
          color: #626880;
          cursor: pointer;
        }

        >.menu-group-active {
          background: #3D4455;
          color: #FFFFFF;
          border-radius: 4px;
        }
      }
    }

    .navigation {
      padding: 0px 0px;
      background-color: #ffffff;
    }

    >.content {
      display: flex;
      flex: 1;
      overflow: hidden;
      margin: 20px;
      background-color: #ffffff;
    }
  }
}
</style>
